import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import {
  FaHome,
  FaBook,
  FaStream,
  FaCalendarAlt,
  FaVideo,
  FaUser,
  FaComments,
  FaSignOutAlt,
  FaCamera,
  FaSun,
  FaMoon,
  FaUserCircle,
  FaChartLine,
} from 'react-icons/fa';
import { isBrowser, isSmartTV } from 'react-device-detect';



const SidebarYou = () => {
  const navigate = useNavigate();
  const [showSubmenu, setShowSubmenu] = useState(false); // ✅ hook fora da condicional
  const [temaAtual, setTemaAtual] = useState(() => {
    const temaSalvo = localStorage.getItem("tema");
    if (temaSalvo) return temaSalvo;
    localStorage.setItem("tema", "dark"); // define como padrão
    document.body.classList.add("dark-mode"); // aplica visualmente
    return "dark";
  });


  if (!(isBrowser || isSmartTV)) return null;

  const rotaAtual = window.location.pathname;



  const logout = () => {
    sessionStorage.removeItem("KEY_APP_BGG");
    navigate("/login");
  };

  const toggleTema = () => {
    const novoTema = temaAtual === "dark" ? "claro" : "dark";
    document.body.classList.toggle("dark-mode");
    localStorage.setItem("tema", novoTema);
    setTemaAtual(novoTema); // <- ESSENCIAL para atualizar dinamicamente
    setShowSubmenu(false);
  };


  const abrirUpload = () => {
    document.getElementById("avatarFileInput")?.click();
    setShowSubmenu(false);
  };

  const links = [
    ...(global.gTipoUser === 'A' ? [
      { href: "/dashboard-admin", label: "Admin", icon: FaChartLine }
    ] : []),
    { href: "/dashboard", label: "Início", icon: FaHome },
    { href: "/feed", label: "Feed", icon: FaStream },
    { href: "/live", label: "Live", icon: FaVideo },
    { href: "/eventos", label: "Eventos", icon: FaCalendarAlt },
    { href: "/cursos", label: "Cursos", icon: FaBook },
    { href: "/mensagens", label: "Mensagens", icon: FaComments },
    {
      href: "#",
      label: "Perfil",
      icon: global.gAvatar ? 'avatar' : FaUser, // string detecta o avatar
      isPerfil: true
    },
  ];


  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '60px',
        height: '100vh',
        backgroundColor: '#111827',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '10px',
        zIndex: 100,
      }}
    >
      {/* Logo da You Evolution */}
      <img
        src="https://youevolution.com.br/wp-content/uploads/2022/03/Logo_You_Evolution_Escudo_250x250.png"
        alt="Logo You Evolution"
        style={{
          height: '45px',
          width: 'auto',
          marginBottom: '24px',
          objectFit: 'contain',
        }}
      />

      {/* Links de navegação */}
      {links.map(({ href, label, icon: Icon, isPerfil }) => (
        <div
          key={label}
          style={{
            marginBottom: '24px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            cursor: 'pointer',
            position: 'relative',
          }}
          onClick={() => {
            if (isPerfil) {
              setShowSubmenu(!showSubmenu);
            } else {
              navigate(href);
            }
          }}
          title={label}
        >
          {Icon === 'avatar' ? (
            <img
              src={global.gAvatar}
              alt="avatar"
              style={{
                width: '35px',
                height: '35px',
                borderRadius: '50%',
                objectFit: 'cover',
                marginBottom: '4px',
                border: '2px solid #60A5FA',
              }}
            />
          ) : (
            <Icon style={{ fontSize: '20px', marginBottom: '4px' }} />
          )}
          <span
            style={{
              fontSize: '11px',
              color: rotaAtual === href ? '#60A5FA' : 'rgba(255,255,255,0.6)',
              fontWeight: rotaAtual === href ? 'bold' : 'normal',
            }}
          >
            {label}
          </span>

          {/* Submenu flutuante */}
          {isPerfil && showSubmenu && (
            <div
              style={{
                position: 'absolute',
                left: '60px',
                bottom: '-10px',
                backgroundColor: temaAtual === "dark" ? "#1f2937" : "#ffffff",
                color: temaAtual === "dark" ? "#ffffff" : "#111827",

                borderRadius: '6px',
                padding: '8px',
                width: '180px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
              }}
            >
              <button className="dropdown-item d-flex align-items-center" onClick={() => {
                setShowSubmenu(false);
                navigate("/perfil");
              }}>
                <FaUserCircle style={{ marginRight: '8px' }} />
                <span>Meu Perfil</span>
              </button>

              <button className="dropdown-item d-flex align-items-center" onClick={abrirUpload}>
                <FaCamera style={{ marginRight: '8px' }} />
                <span>Trocar Imagem</span>
              </button>

              <button className="dropdown-item d-flex align-items-center" onClick={toggleTema}>
                {temaAtual === "dark" ? (
                  <FaSun style={{ marginRight: '8px' }} />
                ) : (
                  <FaMoon style={{ marginRight: '8px' }} />
                )}
                <span>{temaAtual === "dark" ? "Tema Claro" : "Tema Escuro"}</span>
              </button>

              <button className="dropdown-item d-flex align-items-center" onClick={logout}>
                <FaSignOutAlt style={{ marginRight: '8px' }} />
                <span>Sair</span>
              </button>
            </div>
          )}

        </div>
      ))}

      {/* Input invisível */}
      <input
        type="file"
        id="avatarFileInput"
        accept="image/*"
        className="d-none"
        onChange={(e) => {
          const file = e.target.files[0];
          if (file) {
            const formData = new FormData();
            formData.append("avatar", file);
            formData.append("id", global.gIdUser);
            fetch("https://api.youevolution.com.br/upload_avatar.php", {
              method: "POST",
              body: formData,
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.avatarUrl) {
                  global.gAvatar = data.avatarUrl;
                  window.location.reload();
                }
              });
          }
        }}
      />
    </div>
  );
};

export default SidebarYou;
